import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';
import { Tooltip, Grid } from '@mui/material';
import { Dialog, Button } from '@totalsoft/rocket-ui';
import { BoxActionsWrapper } from 'components/common/CommonStyles';

export const WarrantyDataItemSummary = ({ t, warranty, onDeleteWarranty, idx, warrantyItemVisible, deleteDocumentWarranties }) => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const handleDeleteWarranty = useCallback(event => {
    event.preventDefault();
    event.stopPropagation();
    setShowDeleteModal(true);
  }, []);

  const handleDeleteWarrantyPositive = useCallback(
    event => {
      event.preventDefault();
      event.stopPropagation();
      onDeleteWarranty(warranty);
      setShowDeleteModal(false);
    },
    [onDeleteWarranty, warranty]
  );

  const handleDeleteWarrantyClose = useCallback(event => {
    event.preventDefault();
    event.stopPropagation();
    setShowDeleteModal(false);
  }, []);

  return (
    <>
      <Dialog
        open={showDeleteModal}
        onClose={handleDeleteWarrantyClose}
        aria-labelledby='warranties-title'
        aria-describedby='warranties-description'
        title={t('Document.Warranty.DeleteWarranty.Title')}
        content={t('Document.Warranty.DeleteWarranty.DeleteQuestion', {
          data: {
            itemName: warrantyItemVisible
              ? warranty.warrantyItem
                ? warranty.warrantyItem.itemName
                : ''
              : warranty.dictionaryWarrantyTypeName,
            amount: warranty.amount || '',
            currencyCode: warranty.currencyCode || ''
          }
        })}
        actions={
          <BoxActionsWrapper forDialog>
            <Button
              id={'warrantyDataCard_summary_' + idx + '_deleteAcceptBtn'}
              color='primary'
              autoFocus
              onClick={handleDeleteWarrantyPositive}
            >
              {t('Document.Warranty.DeleteWarranty.AcceptButton')}
            </Button>
            <Button id={'warrantyDataCard_summary_' + idx + '_deleteRejectBtn'} color='primary' onClick={handleDeleteWarrantyClose}>
              {t('Document.Warranty.DeleteWarranty.RejectButton')}
            </Button>
          </BoxActionsWrapper>
        }
      />

      <Grid container spacing={1} alignItems='center'>
        {deleteDocumentWarranties && (
          <Grid item sx={{ display: 'flex' }}>
            <Tooltip title={t('Delete')} disableFocusListener={true}>
              <CloseIcon id={'warrantyDataCard_summary_' + idx + '_deleteBtn'} color='error' onClick={handleDeleteWarranty} />
            </Tooltip>
          </Grid>
        )}
        <Grid item xs={12} sm={6}>
          <strong>{t('Document.Warranty.WarrantyItem')}:</strong>{' '}
          <span id={'warrantyDataCard_summary_' + idx + '_name'}>
            {warrantyItemVisible && warranty.warrantyItem ? warranty.warrantyItem.itemName : ''}
            {!warrantyItemVisible && warranty.dictionaryWarrantyTypeName}
          </span>
        </Grid>
        {warranty.amount > 0 && (
          <Grid item xs={12} sm={4}>
            <strong>{t('Document.Warranty.Amount')}:</strong>{' '}
            <span id={'warrantyDataCard_summary_' + idx + '_amount'}>
              {t('DECIMAL', { number: warranty.amount })} {warranty.currency ? warranty.currency.code : ''}
            </span>
          </Grid>
        )}
      </Grid>
    </>
  );
};

WarrantyDataItemSummary.propTypes = {
  t: PropTypes.func.isRequired,
  warranty: PropTypes.object.isRequired,
  onDeleteWarranty: PropTypes.func.isRequired,
  idx: PropTypes.number.isRequired,
  warrantyItemVisible: PropTypes.bool,
  deleteDocumentWarranties: PropTypes.bool
};

export default compose(withTranslation()(WarrantyDataItemSummary));
